import { css } from "@emotion/react";

export const mainContainer = css`
    display: flex;
    width: 100%;
    height: 93.5vh;
    background-color: #EEEEEE;
    overflow: auto;
`

export const header = css`
    display: inline-flex;
    width: 100%;
    height: 48px;
    background-color: #fff;
    border-bottom: 1px solid #dbdbdb;
    box-sizing: border-box;
`

export const sidemenuContainer = css`
    position: relative;
    flex: 0 0 400px;
    width: 320px;
    background-color: #EEEEEE;
`

export const progress = css`
    position: absolute;
    width: 100%;
    height: 3px;
    bottom: 0px;
    left: 0px;
`

export const sidemenuHeaderButton = (isSelected) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 100%;
    border: none;
    background-color: #fff;
    font-size: 18px;
    font-weight: 600;

    color: ${isSelected ? "#036FE2" : "#313131"};

    transition: border 300ms cubic-bezier(0.4, 0, 0.2, 1) 0s;
    border-bottom: ${isSelected ? "2px solid #036FE2" : "2px solid #fff"};

    &:hover {
        border-bottom: ${isSelected ? "2px solid #03FE2" : "2px solid #363636"};
    }
`

export const sidemenuContentContainer = css`
    display: flex;
    flex-direction: column;
    padding: 15px;
`

export const sidemenuContentArea = css`
    display: flex;
    flex-direction: column;
    padding-top: 20px;
`

export const sidemenuContent = css`
    display: flex;
    position: relative;
    flex-direction: column;
    box-sizing: border-box;
    margin: 5px 0px;

    border: 1px solid #dbdbdb;
    border-radius: 4px;
    background-color: #fff;
`

export const mapContainer = css`
    display: flex;
    position: relative;
    flex: 1 0;
    flex-direction: column;
    border-left: 1px solid #D6D6D6;
    border-right: 1px solid #D6D6D6;
    overflow: hidden;
`

export const tableOpenButton = css`
    display: flex;
    align-items: center;
    text-align: center;
    position: absolute;
    bottom: 20px;
    left: 20px;
    padding: 8px;
    font-size: 14px;
    color: #808080;
    background-color: #fff;
    border: none;
    border-radius: 4px;

    cursor: pointer;
`

export const widgetContainer = css`
    flex: 0 0 400px;
    min-width: 300px;
    background-color: #EEEEEE;
`

export const mapArea = css`
    padding: 8px;
    flex: 1;

    .ol-viewport {
        border-radius: 4px;
    }

    .ol-zoom {
        position: absolute;
        background-color: rgba(255,255,255,0.4);
        border-radius: 4px;
        padding: 2px;
        top: 1em;
        right: 1em;
    }

    .ol-control button {
        display: flex;
        margin: 1px;
        font-size: 12px;
        font-weight: bold;
        justify-content: center;
        text-align: center;
        height: 16px;
        width: 16px;
        border: none;
        color: black;
        background-color: white;
    }

    .ol-zoom-in {
        border-radius: 2px 2px 0px 0px;
    }

    .ol-zoom-out {
        border-radius: 0px 0px 2px 2px;
    }

    .ol-rotate {
        display: none;
    }
`

export const table = css`
    width: 100%;
    font-size: 13px;
    border: 1px solid gray;
`

export const thead = css`
    width: 100%;
    height: 30px;
    color: #fff;
    background-color: #999999;
`

export const tbody= css`
    font-weight: 400;
`

export const tr = css`

`

export const thAndTd = css`
    height: 22px;
    text-align: center;
    vertical-align: middle;
    border: 1px solid #a2a2a2;
`

export const val = css`
    height: 22px;
    padding-right: 5px;
    text-align: end;
    vertical-align: middle;
    border: 1px solid #a2a2a2;
`

export const unit = css`
    text-align: end;
    font-size: 13px;
`

export const loadingOverlay = css`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
`;
export const spinner = css`
    width: 48px;
    height: 48px;
    border: 5px solid #ddd;
    border-top-color: #333;
    border-radius: 50%;
    animation: spin 1s linear infinite;

    @keyframes spin {
      to { transform: rotate(360deg); }
    }
`

